









































































































































































































































































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import loading from "@/components/loader/loading.vue";
import {
  MaintenanceRequest,
  MaintenanceRequestResponse,
  PaginatedMaintenanceResponse,
} from "@/api";
import { checkSelfRole, selfData } from "@/common/role_utils";
import _ from "lodash";
import {
  getTaskStatusById,
  getTaskStatusColor,
  taskStatus,
} from "@/common/task_status";
import { dateFormat } from "@/common/date_format";
import moment from "moment";
import MaintenanceRequestForm from "@/views/maintenance_request/MaintenanceRequestForm.vue";
import { maxFileSize } from "@/tool/validation";

@Component({
  components: {
    loading,
    MaintenanceRequestForm,
  },
})
class MaintenanceRequestLayout extends Vue {
  // eslint-disable-next-line
  @Ref("form") form: any;

  isDataLoading = false;
  isAdmin = checkSelfRole("admin");
  isOwner = checkSelfRole("owner");
  selectedTask: Array<MaintenanceRequestResponse> = [];
  expanded = [];
  singleExpand = true;
  employee = 0;
  headers = [
    { text: "ID", value: "id" },
    { text: "Details", value: "details" },
    { text: "Assignee", value: "assignee" },
    { text: "Status", value: "status" },
    { text: "Location", value: "location" },
    { text: "Created At", value: "createdAt" },
    { text: "", value: "data-table-expand" },
  ];
  status = taskStatus;
  counter = 0;
  deletingTask = false;
  updatingTask = false;
  createTaskDialog = false;
  imageDialog = false;
  commentDialog = false;
  taskPayload: MaintenanceRequestResponse | null = null;
  dateFormat = dateFormat;
  getTaskText = getTaskStatusById;
  getTaskColor = getTaskStatusColor;
  self = selfData();
  belongsToMaintenance = false;
  filter: {
    assignee?: number;
    status?: number;
    createdAt?: string;
    completedAt?: string;
  } = {};
  options: {
    page: number;
    itemsPerPage: number;
  } = {
    page: 1,
    itemsPerPage: 10,
  };
  comment = "";
  fileRules = [(v: File) => !v || maxFileSize(v, 5)];
  fileErr = "";
  document: File | null = null;
  documentName = "";
  url: string | ArrayBuffer | null | undefined = "";
  requests: MaintenanceRequestResponse[] = [];
  revertKey = 0;

  // options watcher handles the initial fetch on mount as well
  @Watch("options", { deep: true })
  async onOptionsChange() {
    await this.fetchRequests();
  }

  // Reset to page 1 whenever filters change so offset is always consistent
  @Watch("filter", { deep: true })
  async onFilterChange() {
    this.options.page = 1;
    await this.fetchRequests();
  }

  @Watch("$store.state.maintenanceRequest.requests", { deep: true })
  onRequestsChange(res: PaginatedMaintenanceResponse) {
    this.requests = JSON.parse(JSON.stringify(res?.data ?? []));
  }

  async fetchRequests() {
    await this.$store.dispatch("maintenanceRequest/fetchRequests", {
      ...this.filter,
      limit: this.options.itemsPerPage,
      offset: (this.options.page - 1) * this.options.itemsPerPage,
    });
  }

  async created() {
    this.isDataLoading = true;
    const maintenance = this.fetchRequests();
    const employees = this.$store.dispatch(
      "maintenanceRequest/getMaintenanceEmployees",
    );
    await Promise.all([maintenance, employees]);
    this.isDataLoading = false;
  }

  selfAssigned(employeeId: number): boolean {
    return this.self.id == employeeId;
  }

  get maintenanceRequests(): PaginatedMaintenanceResponse {
    const res = this.$store.state.maintenanceRequest.requests;
    this.belongsToMaintenance = res?.isMaintenance;
    return res;
  }

  get employees() {
    const employeesList = this.$store.state.maintenanceRequest.employees ?? [];
    const list = _.map(
      _.orderBy(employeesList, [
        employee => `${employee.firstName} ${employee.lastName}`.toLowerCase(),
      ]),
      employee => ({
        ...employee,
        text: `${employee.firstName} ${employee.lastName}`,
      }),
    );
    return list;
  }

  clearFilters() {
    this.filter = {};
    // onFilt  matically
  }

  getDeadlineColor(deadline: string): string {
    const today = moment();
    const taskDeadline = moment(deadline);
    if (taskDeadline.isBefore(today, "day")) {
      return "red";
    } else if (taskDeadline.isSame(today, "day")) {
      return "orange";
    }
    return "green";
  }

  updateTask(task: MaintenanceRequestResponse) {
    const requestBody = {
      id: task.id,
      companyId: task.companyId,
      details: task.details,
      assignee: task.assignee?.employeeId,
      status: task.status,
      deadline: task.deadline,
      location: task.location,
      completionComment: task.completionComment,
      completedAt: task.createdAt,
    };

    this.$store.dispatch("maintenanceRequest/updateRequest", {
      payload: requestBody,
    });
    this.taskPayload = null;
    this.commentDialog = false;
    this.counter++;
  }

  updateBulk() {
    if (this.selectedTask.length && this.employee != 0) {
      this.updatingTask = true;
      this.selectedTask.forEach(async (task: MaintenanceRequestResponse) => {
        const requestBody = {
          id: task.id,
          companyId: task.companyId,
          details: task.details,
          assignee: task.assignee?.employeeId,
          status: task.status,
          deadline: task.deadline,
          location: task.location,
          completionComment: task.completionComment,
          completedAt: task.createdAt,
        };

        await this.$store.dispatch("maintenanceRequest/updateRequestAssignee", {
          payload: requestBody,
        });
      });

      this.updatingTask = false;
      this.selectedTask = [];
      this.employee = 0;
    }
  }

  checkBeforeUpdateTask(item: MaintenanceRequestResponse) {
    if (!item?.assignee?.employeeId) {
      const originalRequests =
        this.$store.state.maintenanceRequest.requests?.data ?? [];
      const originalTask = originalRequests.find(
        (t: MaintenanceRequestResponse) => t.id === item.id,
      );
      // eslint-disable-next-line
      (item as any).__previousStatus = originalTask?.status ?? item.status;

      this.taskPayload = item;
      this.$store.dispatch(
        "alert/error",
        "Please assign the task to an employee before changing its status.",
      );

      this.changeToPrevious();
      this.taskPayload = null;
      return;
    }

    if (item.status == 4) {
      // Capture the previous status from the store before opening the dialog
      const originalRequests =
        this.$store.state.maintenanceRequest.requests?.data ?? [];
      const originalTask = originalRequests.find(
        (t: MaintenanceRequestResponse) => t.id === item.id,
      );
      // Stash the original status so changeToPrevious can reliably restore it
      // eslint-disable-next-line
      (item as any).__previousStatus = originalTask?.status ?? item.status;

      this.commentDialog = true;
      this.taskPayload = item;
    } else {
      this.updateTaskStatus(item);
    }
  }

  updateTaskStatus(
    task: MaintenanceRequestResponse | null,
    comment = this.comment,
    file = this.document,
  ) {
    if (task == null) return;
    const requestBody = {
      id: task.id,
      companyId: task.companyId,
      details: task.details,
      assignee: task.assignee?.employeeId || undefined,
      status: task.status,
      deadline: task.deadline,
      location: task.location,
      completionComment: comment,
      completedAt: task.createdAt,
    };

    this.$store.dispatch("maintenanceRequest/updateRequestStatus", {
      payload: requestBody,
      file,
    });
    this.taskPayload = null;
    this.commentDialog = false;
    this.counter++;
    this.form.reset();
  }

  updateTaskAssignee(task: MaintenanceRequestResponse) {
    const requestBody = {
      id: task.id,
      companyId: task.companyId,
      details: task.details,
      assignee: task.assignee?.employeeId,
      status: task.status,
      deadline: task.deadline,
      location: task.location,
      completionComment: task.completionComment,
      completedAt: task.createdAt,
    };

    this.$store.dispatch(
      "maintenanceRequest/updateRequestAssignee",
      requestBody,
    );
    this.taskPayload = null;
    this.commentDialog = false;
    this.counter++;
  }

  deleteTask() {
    if (this.selectedTask.length) {
      this.deletingTask = true;
      this.selectedTask.forEach(async (task: MaintenanceRequestResponse) => {
        const requestBody = {
          id: task.id,
          companyId: task.companyId,
          details: task.details,
          assignee: task.assignee?.employeeId,
          status: task.status,
          deadline: task.deadline,
          location: task.location,
          completionComment: task.completionComment,
          completedAt: task.createdAt,
        } as MaintenanceRequest;

        await this.$store.dispatch(
          "maintenanceRequest/deleteRequest",
          requestBody,
        );
      });

      this.deletingTask = false;
      this.selectedTask = [];
    }
  }

  onChangeFile(file: File) {
    this.fileErr = "";
    if (file) {
      const reader = new FileReader();

      reader.onload = (event: ProgressEvent<FileReader>) => {
        if (event) {
          this.documentName = file.name;
          this.url = URL.createObjectURL(file);
        }
      };
      reader.readAsArrayBuffer(file);
      this.document = file;
    }
  }

  changeToPrevious() {
    if (this.taskPayload) {
      const index = this.requests.findIndex(
        task => task.id === this.taskPayload?.id,
      );

      if (index !== -1) {
        const originalRequests =
          this.$store.state.maintenanceRequest.requests?.data ??
          ([] as MaintenanceRequestResponse[]);
        const previousTask = originalRequests.find(
          (task: MaintenanceRequestResponse) =>
            task.id === this.taskPayload?.id,
        );

        if (previousTask) {
          // splice triggers Vue 2 reactivity, unlike direct index assignment
          this.requests.splice(index, 1, { ...previousTask });
          this.$nextTick(() => {
            this.revertKey++;
          });
        }
      }
    }
  }
}
export default MaintenanceRequestLayout;
